import React from "react";
import {PopoverMenuMoreProps} from "../../../../generic/dropdown/components/popover/popover-menu-more";
import modalAddWebhook from "../../../../../../app/integrations/webhooks/list/components/modal-add-webhook";
import FieldWebhookSelect from "../webhook-select";

type Props = PopoverMenuMoreProps & {
    parent : any                // FieldDropdownLazyLoading_FormView
    field  : FieldWebhookSelect
}

/**
 * "Add webhook" at the bottom of the webhook picker.
 *
 * It creates the webhook in place instead of leaving for Settings ->
 * Integrations -> Webhooks: the reason the picker is open is that a
 * destination is needed right now, and walking out of a half-built automation
 * to get one loses the automation. The new webhook becomes the field's value
 * straight away.
 *
 * (This used to navigate away, on the grounds that a webhook made from a
 * dropdown was "half made" — its secret lived only on the settings page. The
 * secret moved into the modal itself, so that no longer holds.)
 *
 * SAFE ONLY BECAUSE THE PICKER IS NOT IN A MODAL. `gd.modal` has one slot, no
 * stack: `showV5` overwrites whatever is there and `gd.modal.hide()` on submit
 * closes the container. The automation editor is an item view
 * (`gd.goTo('automation/<id>')`), so the slot is free.
 */
export default function FieldWebhookSelect_PopoverMenuMore(props: Props) {

    const onSaved = async (webhook: any) => {

        await props.field.reloadOptions()

        const option = props.field._getOption(webhook.id)

        if (option) props.parent.onOptionClick(option)
    }

    const onClick = (e: React.SyntheticEvent) => {
        e.stopPropagation()

        props.parent.hidePopover()

        modalAddWebhook({onSaved})
    }

    return (
        <div className="help">
            <div className="ui5-link-small" onClick={onClick}>
                Add webhook
            </div>
        </div>
    )
}
